module.exports = __webpack_public_path__ + "static/media/img_give_back@2x.5aa73984.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_give_back@2x.webp
// module id = 814
// module chunks = 0